module.exports = "<div style=\"position: relative;\">\n  <input #input [(ngModel)]=\"value\" style=\"width: 100%\" (focus)=\"$event.target.select()\">\n</div>"